module.exports = __webpack_public_path__ + "static/media/visa.1cec9b02.svg";